<script lang="ts">
  import { categories, type Category } from "$lib/stores/categories.svelte";
  import { onMount } from "svelte";

  let {
    value = $bindable<string | null>(null),
    kind = "expense",
    required = false,
  } = $props<{ value?: string | null; kind?: "income" | "expense"; required?: boolean }>();

  onMount(() => { categories.ensureSeeded(); });

  let opts = $derived<Category[]>(categories.byKind(kind));
</script>

<select class="input" bind:value {required}>
  <option value={null}>— Selecione —</option>
  {#each opts as c}
    <option value={c.id}>{c.icon ?? "•"} {c.name}</option>
  {/each}
</select>
